// extracted by mini-css-extract-plugin
module.exports = {"StockLogo":"StockHeaderLogo_StockLogo__QknP2"};